import { render, staticRenderFns } from "./404Error.vue?vue&type=template&id=6d99f16a&scoped=true"
import script from "./404Error.vue?vue&type=script&lang=js"
export * from "./404Error.vue?vue&type=script&lang=js"
import style0 from "./404Error.vue?vue&type=style&index=0&id=6d99f16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d99f16a",
  null
  
)

export default component.exports